import { trimChars } from 'lodash/fp';

// The snek migration is complete (2026-07-30): every endpoint is served by
// 0xfbadbae (FBADBAE_SERVER). The per-path NEW_BACKEND_PATHS routing table
// that moved endpoints over one at a time is gone; this is now a single
// origin lookup. (RG_SERVER, the old Python backend, is no longer consulted.)
export function getServerOrigin(_path?: string): string {
  // Default to localhost in test to prevent errors that FBADBAE_SERVER is undefined
  if (process.env.NODE_ENV === 'test') {
    return 'http://localhost:8888';
  }

  if (process.env.FBADBAE_SERVER) {
    return process.env.FBADBAE_SERVER;
  }

  // If url not specified. We assume that we are hitting a local path
  return 'http://localhost:5000';
}

export function getServerUrl(path: string): string {
  return `${getServerOrigin(path)}/${trimChars('/')(path)}`;
}
